import styled from "styled-components";
import { Divider, Icon } from "antd";
import { SectionLastHeading, GhostButtonComponent } from "../../../../../../CommonComponents/commonStyles";

export const ComponentDivider = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-top: ${props => props.marginTop};
     margin-bottom: ${props => props.marginBottom};
     background-color: #d4d4d4;
     @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-top: ${props => props.mt};
      margin-bottom: ${props => props.mb};
    }
}
`;

export const SectionHeading = styled(SectionLastHeading)`
font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
margin-bottom: ${props => props.marginBottom};
margin-top: 0 !important;
line-height: 1.5;
font-size: ${props=>props.fSize}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: 20px;
  margin-bottom: ${props => props.mB ? props.mB : props.marginBottom};
}
`;

export const Disclaimer = styled.div`
font-family: HelveticaNeue;
font-size: 16px;
line-height: 1.5;
color: #505050;
margin-top: ${props => props.marginTop};
a {
  text-decoration: underline;
}
& div > p > a {
  color: #006778;
  font-style: normal;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: 14px;
}
`;

export const Guildelines = styled.span`
text-decoration: underline;
color: #006778;
`;

export const SubmitBold = styled.span`
font-family: ${props =>
  props.theme.fontFamily.helveticaNeueBold} ;
`;

export const ContribType = styled.span`
font-family: HelveticaNeue;
font-size: 16px;
color: ${props => props.theme.fontColors.textColor};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: 14px;
}
`;

export const BackIcon = styled(Icon)`
  display: inline-block;
  position: relative;
  transition: left 0.2s;
  @media only screen and (max-width: 990px) {
    left: 5px;
  }
  @media only screen and (max-width: 576px) {
    left: 5px;
  }
`;

export const BackButton = styled(GhostButtonComponent)`
  &:hover ${BackIcon} {
    left: -5px;
  }
`;

export const NavigationBtnContainer = styled.div`
  justify-content: space-between;
  & > div {
    display: flex;
    & button:nth-child(1) {
      margin-right: 1rem;
    }
  }

  @media only screen and (max-width: 991.92px) {
    flex-flow: wrap;
    & > button {
      flex-basis: 100%;
      margin-top: 0.75rem;
    }
  }
`;


export const EditButtonWrap = styled.div`
display: flex;
align-items: center;
`;

export const EditWrap = styled.span`
  margin-left:9px;
  margin-bottom: 20px;
  a{
      img {
        /* width: 10px;
        height: 10px;
        margin-top: 2px; */
      }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) { 
    margin-bottom: ${props => props.mB ? props.mB : '20px'};
  }
`;

export const BusinessDate = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  margin-top: -20px;
  font-size: ${props => props.theme.fontSize.secondary};
  margin-bottom: 20px;
  display: none;
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) { 
    display: block;
  }
  
`;